exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-rater{display:inline-block;line-height:normal}.react-rater a{cursor:pointer;color:#ccc;position:relative}.react-rater a.will-be-active{color:#666}.react-rater a.is-active{color:#000}.react-rater a.is-active-half:before{color:#000;content:\"\\2605\";position:absolute;left:0;width:50%;overflow:hidden}.react-rater a.is-disabled{color:#ccc;cursor:not-allowed}.react-rater.is-disabled a{cursor:default}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/react-rater/lib/react-rater.css
 ** module id = 1064
 ** module chunks = 0
 **/